<app-access-item>
  <app-access-item-icon>
    <app-gallery-settings-icon src="/assets/icons/download-circle.svg"> </app-gallery-settings-icon>
  </app-access-item-icon>
  <app-access-item-header>
    <span>Individual Assets</span>
  </app-access-item-header>
  <app-access-item-cta>
    <app-switch [smallish]="true">
      <input type="checkbox" id="asset-download" [(ngModel)]="assetDownload" (ngModelChange)="updateAssetDownload()" />
      <label for="asset-download" data-test-id="asset-download"></label>
    </app-switch>
  </app-access-item-cta>
</app-access-item>
